"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "report-table": require("./elements/Table.vue").default
  },

  props: ["item"],

  methods: {
    getDataForTable: function getDataForTable(data) {
      var result = [];

      for (var key in data.table_data) {
        data.table_data[key].row_data.unshift(key);
        result.push(data.table_data[key].row_data);
      }

      return result;
    },
    getDataForTableHeader: function getDataForTableHeader(data) {
      data.unshift("");
      return data;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/tables/CompareSummaryTable.vue
// module id = sz5R
// module chunks = 0 1